(() => {
  const VERSION = 'home-global-wiring-2026-05-05-hdd-local';

  if (window.CDHomeAnimationWiring && window.CDHomeAnimationWiring.__version === VERSION) {
    window.CDHomeAnimationWiring.refresh(document);
    return;
  }

  const doc = document;
  const root = doc.documentElement;

  function isHomePage() {
    return !!(
      doc.body &&
      (doc.body.classList.contains('template-index') || root.classList.contains('template-index'))
    );
  }

  function qsa(selector, context = doc) {
    return Array.from(context.querySelectorAll(selector));
  }

  function hasMotion(el) {
    return !!(
      el &&
      (el.hasAttribute('data-cd-animate') ||
        el.hasAttribute('data-cd-motion') ||
        el.hasAttribute('data-cd-split'))
    );
  }

  function markRoot(el) {
    if (el) el.classList.add('cd-home-animation-wired');
  }

  function setMotion(el, kind, opts = {}) {
    if (!el || hasMotion(el)) return;
    el.setAttribute(opts.attr || 'data-cd-animate', kind);
    el.setAttribute('data-cd-home-wired', 'true');

    if (opts.start != null) el.setAttribute('data-cd-motion-start', String(opts.start));
    if (opts.end != null) el.setAttribute('data-cd-motion-end', String(opts.end));
    if (opts.y != null) el.setAttribute('data-cd-motion-y', String(opts.y));
    if (opts.charY != null) el.setAttribute('data-cd-motion-char-y', String(opts.charY));
    if (opts.stagger != null) el.setAttribute('data-cd-motion-stagger', String(opts.stagger));
    if (opts.once != null) el.setAttribute('data-cd-motion-once', String(opts.once));
    if (opts.parallax != null) el.setAttribute('data-cd-motion-parallax', String(opts.parallax));
    if (opts.childStagger != null) el.setAttribute('data-cd-motion-child-stagger', String(opts.childStagger));
    if (opts.soft) el.setAttribute('data-cd-home-motion-soft', 'true');
    if (opts.tight) el.setAttribute('data-cd-home-motion-tight', 'true');
  }

  function setMediaCurtain(el, opts = {}) {
    setMotion(el, 'image-curtain', {
      attr: 'data-cd-motion',
      start: opts.start ?? 0.96,
      end: opts.end ?? 0.52,
      once: opts.once ?? true,
      soft: true,
    });
  }

  function setFadeUp(el, opts = {}) {
    setMotion(el, 'fade-up', {
      start: opts.start ?? 0.96,
      end: opts.end ?? 0.58,
      y: opts.y ?? 34,
      once: opts.once ?? true,
      soft: true,
      tight: opts.tight,
    });
  }

  function setWords(el, opts = {}) {
    // Do not split text nodes that are already controlled by section-specific lineflow scripts.
    if (!el || el.hasAttribute('data-cd-wq-letterflow') || el.hasAttribute('data-cd-dark-lineflow') || el.hasAttribute('data-cd-refills-lineflow') || el.hasAttribute('data-cd-story-lineflow') || el.hasAttribute('data-cd-qm-lineflow') || el.hasAttribute('data-journal-lineflow')) {
      setFadeUp(el, { start: opts.start ?? 0.95, end: opts.end ?? 0.6, y: opts.y ?? 22, tight: true });
      return;
    }

    setMotion(el, 'words', {
      start: opts.start ?? 0.96,
      end: opts.end ?? 0.56,
      charY: opts.charY ?? 0.72,
      stagger: opts.stagger ?? 0.035,
      once: opts.once ?? true,
    });
  }

  function wireMergedStage(context) {
    qsa('.cd-home-merged', context).forEach((section) => {
      markRoot(section);

      qsa('.cd-home-merged__title, .cd-home-merged__description, .cd-home-merged__product-title, .cd-home-merged__product-body, .cd-home-merged__cta, .cd-home-merged__product-button', section).forEach((el) => {
        setFadeUp(el, { start: 0.98, end: 0.62, y: 28 });
      });

      qsa('[data-cd-merged-media], .cd-home-merged__rec-image', section).forEach((el) => {
        setMediaCurtain(el, { start: 0.98, end: 0.56 });
      });
    });
  }

  function wireDarkIntro(context) {
    qsa('.cd-home-dark-intro', context).forEach((section) => {
      markRoot(section);

      // This section is a sticky, clipped reveal. Viewport-based global reveals fire too early
      // inside the hidden shop layer, so the oval/product reveal remains section-controlled.
      // We only layer the global Woodarq fade on the intro copy container.
      qsa('.cd-home-dark-intro__content--motion', section).forEach((el) => {
        setFadeUp(el, { start: 0.96, end: 0.58, y: 30 });
      });
    });
  }

  function removeHomeWiredMotion(el) {
    if (!el || !el.hasAttribute('data-cd-home-wired')) return;

    [
      'data-cd-animate',
      'data-cd-motion',
      'data-cd-split',
      'data-cd-motion-start',
      'data-cd-motion-end',
      'data-cd-motion-y',
      'data-cd-motion-char-y',
      'data-cd-motion-stagger',
      'data-cd-motion-once',
      'data-cd-motion-parallax',
      'data-cd-motion-child-stagger',
      'data-cd-home-motion-soft',
      'data-cd-home-motion-tight',
      'data-cd-motion-split-ready',
      'data-cd-motion-original'
    ].forEach((attr) => el.removeAttribute(attr));

    el.removeAttribute('data-cd-home-wired');
  }

  function wireRefills(context) {
    qsa('.cd-home-refills', context).forEach((section) => {
      markRoot(section);

      // Refills already has a custom Woodarq-style lineflow + center-curtain reveal.
      // Do not add generic global motion here, otherwise the global clip-path curtain can fight
      // the section's own pseudo-element curtain and make the product cards feel clipped/jumpy.
      section.setAttribute('data-cd-motion-ignore', 'true');
      section.setAttribute('data-cd-home-local-motion', 'refills');

      qsa('[data-cd-home-wired], [data-cd-animate], [data-cd-motion], [data-cd-split]', section).forEach(removeHomeWiredMotion);

      if (window.CDHomeRefills && typeof window.CDHomeRefills.rebuild === 'function') {
        window.CDHomeRefills.rebuild();
      } else if (window.CDHomeRefills && typeof window.CDHomeRefills.refresh === 'function') {
        window.CDHomeRefills.refresh();
      }
    });
  }

  function wireStory(context) {
    qsa('.cd-home-story', context).forEach((section) => {
      markRoot(section);

      // Our Story now owns its own Woodarq-style motion: viewport-fixed side rails,
      // local lineflow, parallax and a section-specific media curtain. Keep the global
      // layer away from this section so it cannot add transforms to the sticky words.
      section.setAttribute('data-cd-motion-ignore', 'true');
      section.setAttribute('data-cd-home-local-motion', 'story');

      qsa('[data-cd-home-wired], [data-cd-animate], [data-cd-motion], [data-cd-split]', section).forEach(removeHomeWiredMotion);

      if (window.CDHomeStory && typeof window.CDHomeStory.rebuild === 'function') {
        window.CDHomeStory.rebuild();
      } else if (window.CDHomeStory && typeof window.CDHomeStory.initAll === 'function') {
        window.CDHomeStory.initAll(section);
      }
    });
  }

  function wireDisinfectDry(context) {
    qsa('.cd-hdd, [data-cd-hdd]', context).forEach((section) => {
      markRoot(section);

      // This section already has its own Woodarq-style scroll timeline: text lineflow,
      // fixed/settling product media and section-specific header handoff. Keep global
      // transforms away from the section so the pinned image remains smooth.
      section.setAttribute('data-cd-motion-ignore', 'true');
      section.setAttribute('data-cd-home-local-motion', 'disinfect-dry');

      qsa('[data-cd-home-wired], [data-cd-animate], [data-cd-motion], [data-cd-split]', section).forEach(removeHomeWiredMotion);

      if (window.CDCleerHomeDisinfectDry && typeof window.CDCleerHomeDisinfectDry.mount === 'function') {
        window.CDCleerHomeDisinfectDry.mount();
      } else if (window.CDCleerHomeDisinfectDry && typeof window.CDCleerHomeDisinfectDry.refresh === 'function') {
        window.CDCleerHomeDisinfectDry.refresh();
      }
    });
  }

  function wireQualityMaterials(context) {
    qsa('.cd-quality-materials', context).forEach((section) => {
      markRoot(section);

      qsa('.cd-quality-materials__copy, .cd-quality-materials__copy-desktop, .cd-quality-materials__copy-mobile', section).forEach((el) => setFadeUp(el, { start: 0.96, end: 0.58, y: 24 }));
      // Media scale/position in this section is already scroll-scrubbed by the section file.
      // Keep the global layer on copy only so the existing sticky image transition stays untouched.
    });
  }

  function wireStoryTime(context) {
    qsa('.cd-story-time', context).forEach((section) => {
      markRoot(section);

      qsa('.cd-story-time__name, .cd-story-time__copy, .cd-story-time__copy-title, .cd-story-time__tile, .cd-story-time__code', section).forEach((el) => setFadeUp(el, { start: 0.96, end: 0.58, y: 28 }));
      qsa('.cd-story-time__flow-heading, .cd-story-time__flow-body', section).forEach((el) => setFadeUp(el, { start: 0.96, end: 0.58, y: 30 }));
      // The Story Time image handoff is section-controlled; leave its media transforms untouched.
    });
  }

  function wireJournal(context) {
    qsa('.journal-section', context).forEach((section) => {
      markRoot(section);

      qsa('.journal-heading-wrap', section).forEach((el) => setFadeUp(el, { start: 0.96, end: 0.62, y: 24, tight: true }));
      qsa('.journal-item', section).forEach((el) => setFadeUp(el, { start: 0.98, end: 0.58, y: 32 }));
      qsa('.journal-item__image-wrap', section).forEach((el) => setMediaCurtain(el, { start: 0.98, end: 0.56 }));
      qsa('.journal-item__content', section).forEach((el) => setFadeUp(el, { start: 0.98, end: 0.6, y: 26 }));
    });
  }

  function wireFooter(context) {
    qsa('.cd-home-footer', context).forEach((section) => {
      markRoot(section);

      qsa('.cd-home-footer__logo-wrap', section).forEach((el) => setMediaCurtain(el, { start: 0.98, end: 0.56 }));
      qsa('.cd-home-footer__company, .cd-home-footer__address, .cd-home-footer__phone, .cd-home-footer__signup-row, .cd-home-footer__menu-col, .cd-home-footer__legal-row, .cd-home-footer__copyright', section).forEach((el) => setFadeUp(el, { start: 0.98, end: 0.62, y: 24, tight: true }));
    });
  }

  function refreshGlobal() {
    if (window.CDCleerGlobalAnimations && typeof window.CDCleerGlobalAnimations.refresh === 'function') {
      window.CDCleerGlobalAnimations.refresh();
    }
  }

  function wire(context = doc) {
    if (!isHomePage()) return;

    wireMergedStage(context);
    wireDarkIntro(context);
    wireRefills(context);
    wireStory(context);
    wireDisinfectDry(context);
    wireQualityMaterials(context);
    wireStoryTime(context);
    wireJournal(context);
    wireFooter(context);

    refreshGlobal();
  }

  function ready(fn) {
    if (doc.readyState === 'loading') {
      doc.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(() => {
    root.classList.add('cd-home-animation-wiring-ready');
    wire(doc);
    window.addEventListener('load', () => wire(doc), { once: true });
  });

  doc.addEventListener('shopify:section:load', (event) => wire(event.target || doc));
  doc.addEventListener('shopify:section:reorder', () => wire(doc));

  window.CDHomeAnimationWiring = {
    __version: VERSION,
    refresh: wire,
  };
})();
